import API from "../API/Api"

export default {

  getStores: async function () {
    try {
      const response = await API.get('lojas');
      return response.data || [];
    } catch (error) {
      return { error: true, message: error }
    }
  },

  getItensPedido: async function (body = { tableNumber: 0, storeID: 0 }) {
    try {
      let headers = { "Content-Type": " application/json" };

      const response = await API.post('pedidosmesa', body, { headers });

      console.log(response.data.pedido.itens)
      return response.data.pedido.itens

    } catch (error) {
      return []
    }
  },
  callWaiter: async function (body = { tableNumber: 0, storeID: 0, status: 0 }) {
    try {
      let headers = { "Content-Type": " application/json" };

      const response = await API.post('setstatuswaiter', body, { headers });

      return response.data.status === 0;

    } catch (error) {
      return false
    }
  },
  setStatusTable: async function (body = { tableNumber: 0, storeID: 0, status: 0 }) {
    try {
      let headers = { "Content-Type": " application/json" };

      const response = await API.post('setstatustable', body, { headers });

      return response.data.status === 0;

    } catch (error) {
      return false
    }
  }

}